import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule }
	from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor } from '@angular/common';
import {
	FormArray,
	FormControl,
	FormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { FileUploadModule } from '@copo/file-upload-new';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpErrorResponse } from '@angular/common/http';

import { CodeValue } from '../../../../shared/models/boc-available-value';
import { UserService } from '../../../../shared/services/user.service';
import {
	coilList, innerDiameterList, plant, plantsInFrench, SHIP_TO_CUSTOM, FORM_BLANK, FORM_SHEET, EMPTY_LINE,
	FORM_COIL, FORM_SLITTING_COIL, currencyList, EPOCH, EMPTY_DISPLAY, UNIT_SHEET, UNIT_BLANKS,
	MILLISECONDS_IN_A_DAY, SESSION_UPDATED, NONE_CODE,
	langList,
	formValuesForAllLang,
	transportModeForAllLang,
	unitListForCoilForAllLang,
	unitListForSheetForAllLang,
	unitListForBlankForAllLang,
	unitsForAllLang,
	innerDiameterDefaultValueAllLang,
	defaultValueForAllLang
} from '../../../models/fastlane-list';
import {
	globalValidationConfig, ValidationConfig, headerValidationConfig,
	itemValidationConfig, ErrorObj, CellData
} from '../../../models/fastlane-excel-config';
import { FastLaneRequest, FastLaneItem, ValueAndDisplay } from '../../../models/fastlane.model';
import { FastLaneService } from '../../../services/fastlane.service';
import { WorkerService } from '../../../../shared/services/worker.service';
import { TranslationService } from '../../../../shared/services/translation.service';
import { DATE_FORMAT_PATTERN_DD_MM_YYYY, WEEKYEAR_FORMAT_PATTERN } from '../../../../shared/models/filter-formats';
import { AttachmentService } from '../../../services/fastlane-attachment-service';
import { FastLaneWizardService } from '../../../services/fastlane-wizard.service';
import { FormFastLane } from '../../../models/form-fastlane';

interface IDialogTitleContent {
	title: string;
	content1: string;
	content2: string;
	content3: string;
	content4: string;
	content5: string;
	resultLabel: string;
	result: string;
	button: string;
	transKeyMapResponse: Map<string, Map<string, string>>;
}

@Component({
	selector: 'copo-dialog-file-upload',
	templateUrl: './dialog-file-upload.component.html',
	styleUrl: './dialog-file-upload.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		NgIf,
		NgFor,

		MatDialogModule,
		TranslateModule,
		MatIconModule,

		MatButtonModule,

		MatProgressSpinnerModule,
		FileUploadModule
	],
})
export class DialogFileUploadComponent implements OnInit {
	errorMessage = '';
	reader: FileReader = new FileReader();
	errors: ErrorObj[] = [];
	fastlaneRequest!: FastLaneRequest;
	incotList?: CodeValue[];
	readonly emptyline = EMPTY_LINE;
	noneLabel = '';
	itemsInErrorCount = 0;
	isValidating = false;
	transKeyMapResponse: Map<string, Map<string, string>> = new Map<string, Map<string, string>>();
	fastLaneItems: FastLaneItem[] = [];
	dropDownOptionsMap: Map<string, Record<string, string>> = new Map<string, Record<string, string>>();
	readonly form: FormFastLane;
	private fileToUpload: File | undefined;

	constructor(

		@Inject(MAT_DIALOG_DATA) public dialogContent: IDialogTitleContent,

		private readonly dialogRef: MatDialogRef<DialogFileUploadComponent>,
		private readonly translationService: TranslationService,
		private readonly userService: UserService,
		private readonly fastlaneService: FastLaneService,
		readonly workerService: WorkerService,
		private readonly snackBar: MatSnackBar,
		private readonly fastlaneWizardService: FastLaneWizardService,
		private readonly attachmentService: AttachmentService
	) {
		this.transKeyMapResponse = dialogContent.transKeyMapResponse;
		this.incotList = this.bocAvailableValues('INCOT');
		this.noneLabel = this.translationService.getTR('fastlane.itemlist.product.coil_axis.default');
		this.form = this.fastlaneWizardService.getStateFastLaneForm();
	}

	ngOnInit() {
		this.dialogRef.updateSize('auto', 'auto');
		this.dialogContent.result = this.translationService.getTR('dialog-upload-file');
		this.dropDownOptionsMap.set('currency', this.preparCurrencyValues());
		this.dropDownOptionsMap.set('form', this.prepareValuesForAllLang(formValuesForAllLang, {}));
		this.dropDownOptionsMap.set(
			'coilAxis',
			this.prepareValuesForAllLang(defaultValueForAllLang, this.prepareDescriptionAndCodes(coilList))
		);
		this.dropDownOptionsMap.set(
			'innerDiameter',
			this.prepareValuesForAllLang(
				innerDiameterDefaultValueAllLang,
				this.prepareDescriptionAndCodes(innerDiameterList)
			)
		);
		this.dropDownOptionsMap.set(
			'transportMode',
			this.prepareValuesForAllLang(
				defaultValueForAllLang,
				this.prepareValuesForAllLang(transportModeForAllLang, {})
			)
		);
		this.dropDownOptionsMap.set('plant', this.preparePlantValues());
		this.dropDownOptionsMap.set(
			'incoterms',
			this.prepareValuesForAllLang(defaultValueForAllLang, this.prepareIncotermValues())
		);
		this.dropDownOptionsMap.set('quantityUnit', this.prepareValuesForAllLang(unitsForAllLang, {}));
		this.dropDownOptionsMap.set('unit_coil', this.prepareValuesForAllLang(unitListForCoilForAllLang, {}));
		this.dropDownOptionsMap.set('slitting_coil', this.prepareValuesForAllLang(unitListForCoilForAllLang, {}));
		this.dropDownOptionsMap.set('unit_sheet', this.prepareValuesForAllLang(unitListForSheetForAllLang, {}));
		this.dropDownOptionsMap.set('unit_blanks', this.prepareValuesForAllLang(unitListForBlankForAllLang, {}));
	}

	checkErrorCount() {
		return this.errors.length > 0;
	}

	async addAttachments(events: FileList) {
		try {
			this.errors.length = 0;
			const files = Array.from(events);
			this.fastLaneItems = [];
			this.itemsInErrorCount = 0;
			if (files.length > 1) {
				this.errorMessage = this.translationService.getTR('upload.file.count.error.message');
				this.errorMessage = this.errorMessage.replace('-max-count-', '1');
			} else {
				const localErrors: ErrorObj[] = [];
				const [file] = files;
				if (file.type !== 'application/vnd.ms-excel'
					&& file.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
					localErrors.push({
						row: -1,
						errorCode: this.translationService.getTR('fastlane.template.xls.mime.type')
					});
				} else {
					this.fileToUpload = file;
					const arrayBuffer = await file.arrayBuffer();
					this.processExcelContent(arrayBuffer);
				}
				this.handleError(-1, '', 'fastlane.template.global.error', localErrors, -1);
			}
		} catch (err) {
			this.errors.push({
				row: -1,
				errorCode: this.translationService.getTR('global.unexpected.error.identified')
			});
			throw err;
		}
	}

	getErrorMsg(): string[] {
		return [this.errorMessage];
	}

	async validate() {
		this.isValidating = true;
		const productFormGroup: FormGroup = new FormGroup({
			productSpecifications: new FormArray([]),
		});
		const control = <FormArray> productFormGroup.controls['productSpecifications'];
		for (const item of this.fastLaneItems) {
			control.push(this.fastlaneService.createFastlaneFormGroup(item));
		}
		this.fastlaneService.productFormGroup = productFormGroup;
		const attachmentFormGroups = <FormArray> this.form.get('fastLaneAttachments');
		const attachmentErrorControl = <FormControl> this.form.get('attachmentErrorMessages');

		this.isValidating = false;
		if (this.fileToUpload && !this.attachmentService.checkMaxFileLimit([this.fileToUpload], attachmentFormGroups)) {
			this.snackBar.open(
				this.translationService.getTR('upload.file.space.error.message'),
				undefined,
				{
					duration: 10_000,
				}
			);
		} else if (this.fileToUpload) {
			try {
				await this.attachmentService.uploadFiles(
					[this.fileToUpload],
					attachmentFormGroups,
					attachmentErrorControl
				);
			} catch (error: unknown) {
				if (error instanceof HttpErrorResponse) {
					const errormessage = <string> this.form.get('attachmentErrorMessages')?.value;
					this.snackBar.open(
						errormessage,
						undefined,
						{
							duration: 5000,
						}
					);
					return;
				}
			}
		}

		this.dialogRef.close(SESSION_UPDATED);
	}

	/**
	 * Read excel template
	 * Read the global validation config and validate the excel for global issues, and stop process on error
	 * Read the header validation config and validate the excel for header level issues
	 * Read the item level validation config and validate the excel for Item level issues
	 * Show header and item level details which are in error.
	 * Display the information on items without any error
	 * @param input - excel content in ArrayBuffer
	 */
	private processExcelContent(input: ArrayBuffer | undefined) {
		if (input) {
			const worker = this.workerService.readExcelWorker();
			worker.addEventListener('message', ({ data }: { data: { sheetName: string; data: unknown[][] }[] }) => {
				try {
					this.errors = [];
					worker.terminate();
					const requestSheet = data.find(sheet => sheet.sheetName === 'Request')?.data || [];
					if (!this.templateGlobalErrorCheck(requestSheet)) {
						this.fastlaneRequest = this.processHeaderPartOfTemplate(requestSheet);
						this.processProductItemsOfTemplate(requestSheet);
					}
					this.errorHandling();
				} catch (err) {
					this.errors.push({
						row: -1,
						errorCode: this.translationService.getTR('global.unexpected.error.identified')
					});
					throw err;
				}
			});
			const inputArray = new Uint8Array(input);
			worker.postMessage({
				inputArray
			});
		}
	}

	private getCellData(sheet: unknown[][], row: number, column: number) {
		if (!Array.isArray(sheet) || row >= sheet.length || row < 0) {
			return undefined;
		}
		const rowData = sheet[row];
		if (!Array.isArray(rowData) || column >= rowData.length || column < 0) {
			return undefined;
		}
		return rowData[column];
	}

	/**
	 * Read the global validation config and validate the excel for global issues, and stop process on error
	 * @param sheet - excel sheet to do global check
	 * @returns checkFailed - global check state
	 */
	private templateGlobalErrorCheck(sheet: unknown[][]) {
		const localErrors: ErrorObj[] = [];
		let checkFailed = false;
		for (const key of Object.keys(globalValidationConfig)) {
			const config = globalValidationConfig[key];
			const celldata = this.processCellValue(key, sheet, config, config.row, -1);
			if (celldata.error) {
				localErrors.push(celldata.error);
				break;
			}
		}
		if (localErrors.length > 0) {
			this.handleError(-1, '', 'fastlane.template.global.error', localErrors, -1);
			checkFailed = true;
		}
		return checkFailed;
	}

	/**
	 * Read the header validation config and validate the excel for header level issues
	 * @param sheet - excel sheet to do global check
	 * @returns header object
	 */
	private processHeaderPartOfTemplate(sheet: unknown[][]) {
		let requestName = '';
		let shipToCustom = '';
		let description = '';
		let currency = '';
		const localErrors: ErrorObj[] = [];

		for (const key of Object.keys(headerValidationConfig)) {
			const config = headerValidationConfig[key];
			const celldata = this.processCellValue(key, sheet, config, config.row, 0);
			const value = !celldata.value ? '' : String(celldata.value);
			switch (key) {
			case 'requestName':
				requestName = value;
				break;
			case 'shipToCustom':
				shipToCustom = value;
				break;
			case 'description':
				description = value;
				break;
			case 'currency':
				currency = value;
				break;
			}

			if (celldata.error) {
				celldata.error.errorCode = `- ${ this.translationService.getTR('fastlane.template.request') }
											: ${ celldata.error.errorCode }`;
				localErrors.push(celldata.error);
			}
		}
		if (localErrors.length > 0) {
			this.handleError(0, '', 'fastlane.template.global.data.issue', localErrors, 0);
		}
		return {
			requestName,
			shipTo: SHIP_TO_CUSTOM,
			shipToCustom,
			shipToPerson: 'N/A',
			shipToContact: 'N/A',
			soldTo: '',
			description,
			currency
		};
	}

	/**
	 * Read the item level validation config and validate the excel for Item level issues
	 * @param sheet - excel sheet to do global check
	 */
	private processProductItemsOfTemplate(sheet: unknown[][]) {
		const validItems: FastLaneItem[] = [];
		const localErrors: ErrorObj[] = [];
		const maxItemsCount = 50;
		let itemCount;
		for (itemCount = 0; itemCount < maxItemsCount; itemCount++) {
			let itemNumber = '';
			let name = '';
			let steelgrade = '';
			let form = '';
			let thickness = 0;
			let width = 0;
			let length = 0;
			let blankWeight;
			let quantity = 0;
			let quantityUnit = 'tons';
			let coating = '';
			let coilAxis;
			let oiling;
			let innerDiameter;
			let maxOutsideDiameter;
			let additionalItemInfo;
			let rddDisplay;
			let rddDate;
			let rddType = '2';
			let transportModeCode;
			let incoterms;
			let packing;
			let plantCode;
			let shipToCustom;
			const itemLevelErrors: ErrorObj[] = [];
			let isQuantityUnitValid = true;
			let isFormEmpty = false;
			for (const key of Object.keys(itemValidationConfig)) {
				if (this.isValidationRequiredBasedOnForm(form, key)) {
					continue;
				}
				if (this.skipValidationForSpecificUnits(isQuantityUnitValid, key)) {
					continue;
				}

				const config = itemValidationConfig[key];
				const row = itemCount + config.row;
				if (key === 'quantity') {
					config.decimalCount = quantityUnit
						&& (quantityUnit === UNIT_SHEET || quantityUnit === UNIT_BLANKS) ? 0 : 2;
				}
				const celldata = this.processCellValue(key, sheet, config, row, row);

				switch (key) {
				case 'itemNumber':
					itemNumber = celldata.value;
					break;
				case 'name':
					name = celldata.value;
					break;
				case 'steelgrade':
					steelgrade = celldata.value;
					break;
				case 'form':
					form = celldata.value;
					if (celldata.error && celldata.error.param1 === EMPTY_DISPLAY) {
						isFormEmpty = true;
					}
					break;
				case 'thickness':
					if (celldata.isValidType) {
						thickness = Number(celldata.value);
					}
					break;
				case 'width':
					if (celldata.isValidType) {
						width = Number(celldata.value);
					}
					break;
				case 'length':
					if (celldata.isValidType) {
						length = Number(celldata.value);
					}
					break;
				case 'blankWeight':
					if (celldata.isValidType) {
						blankWeight = Number(celldata.value);
					}
					break;
				case 'quantity':
					quantity = Number(celldata.value);
					break;
				case 'quantityUnit':
					isQuantityUnitValid = !celldata.error;
					quantityUnit = celldata.value;
					break;
				case 'coating':
					coating = celldata.value;
					break;
				case 'coilAxis':
					coilAxis = celldata.value;
					break;
				case 'oiling':
					oiling = celldata.value;
					break;
				case 'innerDiameter':
					innerDiameter = celldata.value;
					break;
				case 'maxOutsideDiameter':
					if (celldata.isValidType) {
						maxOutsideDiameter = Number(celldata.value);
					}
					break;
				case 'additionalItemInfo':
					additionalItemInfo = celldata.value;
					break;
				case 'rddDisplay':
					rddDisplay = celldata.value;
					if (rddDisplay) {
						rddDate = moment(rddDisplay, WEEKYEAR_FORMAT_PATTERN).toDate();
					}
					break;
				case 'rddDate':
					if (celldata.isValidType) {
						const dayFormatDate = this.getDateCellValue(celldata.value, config);
						if (dayFormatDate) {
							rddType = '1';
							rddDate = moment(dayFormatDate, DATE_FORMAT_PATTERN_DD_MM_YYYY).toDate();
							if (rddDisplay) {
								const dateInWeekFormat = moment(rddDate).format(WEEKYEAR_FORMAT_PATTERN);
								if (rddDisplay !== dateInWeekFormat) {
									itemLevelErrors.push({
										row: itemCount,
										errorCode: `- ${ this.translationService.getTR('fastlane.template.line') }
											${ itemNumber }
										: ${ this.translationService.getTR('fastlane.template.rddwnd.validation') }`,
										param1: rddDisplay,
										param2: dayFormatDate.toLocaleString()
									});
								}
							}
						}
					}
					break;
				case 'transportMode':
					transportModeCode = celldata.value;
					break;
				case 'incoterms':
					incoterms = celldata.value;
					break;
				case 'packing':
					packing = celldata.value;
					break;
				case 'plant':
					plantCode = celldata.value;
					break;
				case 'shipToCustom':
					shipToCustom = celldata.value;
					break;
				}

				if (celldata.error) {
					celldata.error.errorCode = `- ${ this.translationService.getTR('fastlane.template.line') }
												${ itemNumber } : ${ celldata.error.errorCode }`;
					itemLevelErrors.push(celldata.error);
				}
			}

			switch (form) {
			case FORM_COIL:
			case FORM_SLITTING_COIL:
				length = 0;
				blankWeight = 0;
				break;
			case FORM_SHEET:
				blankWeight = 0;
				coilAxis = NONE_CODE;
				innerDiameter = '';
				maxOutsideDiameter = 0;
				break;
			case FORM_BLANK:
				width = 0;
				length = 0;
				coilAxis = NONE_CODE;
				innerDiameter = '';
				maxOutsideDiameter = 0;
				break;
			}

			// Consider row is empty
			if ((!name || name.length === 0) && (!steelgrade || steelgrade.length === 0)
				&& isFormEmpty && !thickness) {
				break;
			}
			const itemObject: FastLaneItem = {
				itemNumber,
				name,
				steelgrade,
				form,
				thickness,
				width,
				length,
				blankWeight,
				quantity,
				quantityUnit,
				coating,
				coilAxis,
				oiling,
				innerDiameter,
				maxOutsideDiameter,
				additionalItemInfo,
				rddDisplay,
				rddType,
				rddDate,
				transportMode: transportModeCode,
				incoterms,
				packing,
				plant: plantCode,
				shipTo: SHIP_TO_CUSTOM,
				shipToCustom,
				shipToPerson: 'N/A',
				shipToContact: 'N/A',
			};
			if (itemLevelErrors.length > 0) {
				this.itemsInErrorCount++;
				this.fastLaneItems.push(itemObject);
			} else if (itemNumber && name && steelgrade && form.length > 0 && thickness > 0
				&& quantity > 0 && coating) {
				validItems.push(itemObject);
			}
			localErrors.push(...itemLevelErrors);
		}

		this.errors.push(
			{
				row: 1,
				errorCode: this.translationService.getTR('fastlane.template.detected.items'),
				param1: String(itemCount)
			},
			{
				row: 0,
				errorCode: EMPTY_LINE
			}
		);
		if (localErrors.length > 0) {
			this.handleError(
				1,
				String(this.itemsInErrorCount),
				'fastlane.template.item.issue.header',
				localErrors,
				this.itemsInErrorCount
			);
		}
		this.handleValidItems(validItems);
		this.fastLaneItems.push(...validItems);
		this.fastLaneItems.sort((a, b) => Number(a.itemNumber) - Number(b.itemNumber));
	}

	private isValidationRequiredBasedOnForm(form: string, key: string) {
		return form
			&& ((form === FORM_BLANK
				&& (key === 'width' || key === 'length' || key === 'unit_coil' || key === 'slitting_coil'
					|| key === 'unit_sheet'))
				|| (form === FORM_SHEET
					&& (
						key === 'blankWeight'
						|| key === 'unit_coil'
						|| key === 'slitting_coil'
						|| key === 'unit_blanks'
					))
					|| (form === FORM_COIL
						&& (key === 'blankWeight' || key === 'length'
							|| key === 'unit_sheet' || key === 'unit_blanks' || key === 'slitting_coil'))
						|| (form === FORM_SLITTING_COIL
							&& (key === 'blankWeight' || key === 'length'
								|| key === 'unit_sheet' || key === 'unit_blanks' || key === 'unit_coil')));
	}

	private skipValidationForSpecificUnits(isQuantityUnitValid: boolean, key: string) {
		return !isQuantityUnitValid
			&& (key === 'unit_coil' || key === 'slitting_coil' || key === 'unit_sheet' || key === 'unit_blanks');
	}

	private processCellValue(
		key: string,
		sheet: unknown[][],
		config: ValidationConfig,
		row: number,
		errorRowNumber: number
	) {
		const cellValue = this.getCellData(sheet, row, config.column);
		const cellData: CellData = {
			value: this.getStringCellValue(cellValue),
			isValidType: true
		};
		const errorCodes = this.validateCell(cellData, config, key);
		if (errorCodes.length > 0) {
			this.handleCellErrors(cellData, errorCodes, config, errorRowNumber);
		}
		if (config.isDropDown) {
			const records = this.dropDownOptionsMap.get(key);
			cellData.value = records?.[cellData.value] || '';
		}
		this.handleDefaultValue(cellData, config);
		return cellData;
	}

	private validateCell(cellData: CellData, config: ValidationConfig, key: string) {
		if (this.isMandatoryInvalid(cellData.value, config)) {
			return config.errorCodes;
		}
		if (this.isDateTypeInvalid(cellData.value, config)) {
			cellData.isValidType = false;
			return config.errorCodes;
		}
		if (this.isMaxLengthExceeded(cellData.value, config)) {
			return config.errorCodes;
		}
		if (this.isInvalidNumber(cellData.value, config)) {
			cellData.isValidType = false;
			return config.errorCodes;
		}
		if (this.isValueOutOfRange(cellData.value, config)) {
			return config.errorCodes;
		}
		if (this.isDecimalCountExceeded(cellData.value, config)) {
			return config.errorCodes;
		}
		if (this.isDropDownInvalid(cellData.value, config, key)) {
			return config.errorCodes;
		}
		if (this.isValueInvalid(cellData.value, config)) {
			return config.errorCodes;
		}
		return [];
	}

	private isMandatoryInvalid(value: string, config: ValidationConfig): boolean {
		return config.mandatory && value.trim().length === 0;
	}

	private isDateTypeInvalid(value: string, config: ValidationConfig): boolean {
		return config.type === 'date' && Number.isNaN(Number(value))
			&& !moment(value, config.dateFormat, true).isValid();
	}

	private isMaxLengthExceeded(value: string, config: ValidationConfig) {
		return config.maxLength
			&& value.trim().length > (config.maxLength || Number.POSITIVE_INFINITY);
	}

	private isInvalidNumber(value: string, config: ValidationConfig): boolean {
		return config.type === 'number' && value.trim().length !== 0 && Number.isNaN(Number(value));
	}

	private isValueOutOfRange(value: string, config: ValidationConfig): boolean {
		if (config.type === 'number' && value.length > 0) {
			const numValue = Number(value);
			return (config.min !== undefined && numValue < config.min)
				|| (config.max !== undefined && numValue > config.max);
		}
		return false;
	}

	private isDecimalCountExceeded(value: string, config: ValidationConfig) {
		if (config.type === 'number' && config.decimalCount !== undefined && value.length > 0) {
			const numValue = Number(value);
			return this.decimalCount(numValue) > config.decimalCount;
		}
		return false;
	}

	private isDropDownInvalid(
		value: string,
		config: ValidationConfig,
		key: string
	) {
		return config.isDropDown && !this.isValidDropDownValue(value, key);
	}

	private isValidDropDownValue(value: string, key: string): boolean {
		const records = this.dropDownOptionsMap.get(key);
		return Boolean(records?.[value]);
	}

	private isValueInvalid(value: string, config: ValidationConfig) {
		return config.values && !config.values.includes(value);
	}

	private getStringCellValue(cellValue: unknown): string {
		if (cellValue !== null
			&& (typeof cellValue === 'string' || typeof cellValue === 'number'
				|| typeof cellValue === 'boolean')) {
			return cellValue.toString();
		}
		return '';
	}

	private getDateCellValue(cellValue: string, config: ValidationConfig): Date | string {
		if (cellValue !== '') {
			if (!Number.isNaN(Number(cellValue))) {
				/**
				 * Excel converts date to a numeric representation mostly Number of days from Jan 1 1900
				 * EPOCH - number of days from Jan 1, 1900 to Jan 1, 1970
				 * MILLISECONDS_IN_A_DAY 0 - number of miliseconds in a day
				 */
				return new Date((Number(cellValue) - EPOCH) * MILLISECONDS_IN_A_DAY);
			} else if (moment(cellValue, config.dateFormat, true).isValid()) {
				return moment(cellValue, config.dateFormat).toDate();
			}
		}
		return cellValue;
	}

	/**
	 * Show header and item level details which are in error.
	 * @param cellData - cell related detail
	 * @param errorCodes - errors identified
	 * @param config - validation state of cell
	 * @param errorRowNumber - line number of error
	 */
	private handleCellErrors(
		cellData: CellData,
		errorCodes: string[],
		config: ValidationConfig,
		errorRowNumber: number
	): void {
		const errorDescription = errorCodes.map(code => this.translationService.getTR(code)).join(': ');
		let paramX;
		if (config.errorParamX === 'size') {
			paramX = String(cellData.value.length);
		} else if (config.errorParamX === 'value') {
			paramX = cellData.value && cellData.value.trim().length > 0 ? cellData.value : EMPTY_DISPLAY;
		}
		if (config.trimOnExceed && cellData.value.length > 0) {
			cellData.value = cellData.value.trim();
			if (config.maxLength !== undefined) {
				cellData.value = cellData.value.slice(0, config.maxLength);
			}
		}
		if (cellData.value && config.type === 'number' && cellData.isValidType) {
			const numberValue = Number(cellData.value);
			if (config.min && numberValue < config.min) {
				cellData.value = String(config.min);
			} else if (config.max && numberValue > config.max) {
				cellData.value = String(config.max);
			}
			if (config.trimOnExceed) {
				cellData.value = this.updateDecimalCount(cellData.value, config);
			}
		}
		cellData.error = {
			row: errorRowNumber,
			errorCode: errorDescription,
			param1: String(paramX),
			param2: config.errorParamY ? this.translationService.getTR(config.errorParamY) : ''
		};
	}

	private handleDefaultValue(cellData: CellData, config: ValidationConfig): void {
		if (config.defaultValue && cellData.value === '') {
			cellData.value = config.defaultValue;
		}
	}

	/**
	 * Display the information on items without any error
	 * @param validItems - items without any error
	 */
	private handleValidItems(validItems: FastLaneItem[]) {
		if (validItems.length > 0) {
			this.errors.push({
				row: 1,
				errorCode: `${ this.translationService.getTR('fastlane.template.valid.items') }:`,
				param1: String(validItems.length)
			});

			for (const item of validItems) {
				let dim = '';
				let qty = '';
				const unit = typeof item.quantityUnit === 'string' ? item.quantityUnit : '';
				if (typeof item.form === 'string') {
					switch (item.form) {
					case FORM_COIL:
					case FORM_SLITTING_COIL:
						dim = `${ item.thickness } x ${ item.width }`;
						qty = `${ item.quantity } ${ unit }`;
						break;
					case FORM_SHEET:
						dim = `${ item.thickness } x ${ item.width } x ${ item.length }`;
						qty = `${ item.quantity } ${ unit }`;
						break;
					case FORM_BLANK:
						dim = `${ item.thickness }`;
						qty = `${ item.blankWeight } x ${ item.quantity } t`;
						break;
					}
				}
				this.errors.push({
					row: 1,
					errorCode: `- ${ this.translationService.getTR('fastlane.template.line') }
					${ item.itemNumber } : ${ item.name } ${ item.steelgrade } ${ dim } ${ qty }`
				});
			}
		}
	}

	private handleError(
		rowValue: number,
		param1Value: string,
		errorCode: string,
		localErrors: ErrorObj[],
		emptyLineRow: number
	) {
		if (localErrors.length > 0) {
			this.errors.push(
				{
					row: rowValue,
					errorCode: `${ this.translationService.getTR(errorCode) }: `,
					param1: param1Value
				},
				...localErrors,
				{
					row: emptyLineRow,
					errorCode: EMPTY_LINE
				}
			);
		}
	}

	private errorHandling() {
		for (const error of this.errors) {
			error.errorCode = error.param1 ? error.errorCode.replace('[X]', error.param1)
				: error.errorCode.replace('[X]', '');
			error.errorCode = error.param2 ? error.errorCode.replace('[Y]', error.param2)
				: error.errorCode.replace('[Y]', '');
		}
	}

	private decimalCount(input: number) {
		if (input % 1 !== 0) {
			return input.toString().split('.')[1].length;
		}
		return 0;
	}

	private updateDecimalCount(input: string, config: ValidationConfig) {
		const arr = input.split('.');
		if (arr.length === 2) {
			let result = arr[0].toString();
			if (config.decimalCount) {
				result = `${ result }.${ arr[1].slice(0, config.decimalCount) }`;
			}
			return result;
		}
		return input;
	}

	/**
	 * generate key value pair => display label as key, code as value
	 * @param inputValues - contains code and display value
	 * @returns records
	 */
	private prepareDescriptionAndCodes(inputValues: ValueAndDisplay[]) {
		const records: Record<string, string> = {};
		for (const input of inputValues) {
			records[this.translationService.getTR(input.display)] = input.value;
		}
		return records;
	}

	private preparePlantValues() {
		const mills = [...plantsInFrench, ...plant];
		const records: Record<string, string> = {};
		for (const mill of mills) {
			records[mill.value] = mill.code;
		}
		return records;
	}

	private preparCurrencyValues() {
		const records: Record<string, string> = {};
		for (const currency of currencyList) {
			records[currency.code] = currency.code;
		}
		return records;
	}

	private prepareIncotermValues() {
		const records: Record<string, string> = {};
		if (this.incotList) {
			for (const incot of this.incotList) {
				records[incot.code] = incot.code;
			}
			records[this.noneLabel] = NONE_CODE;
		}
		return records;
	}

	private prepareValuesForAllLang(input: Map<string, string>, record: Record<string, string>) {
		for (const lang of langList) {
			const transResponse = this.transKeyMapResponse.get(lang);
			if (transResponse) {
				for (const key of input.keys()) {
					const index = transResponse.get(key);
					const value = input.get(key);
					if (index && value) {
						record[index] = value;
					}
				}
			}
		}
		return record;
	}

	private bocAvailableValues(parameter: string) {
		return this.userService.getBocAvailableValuesBasedOnCode('PFAST', parameter);
	}
}
